import firebase from "firebase/app";
import "firebase/storage";
import "firebase/database";
import "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBovWC_jzhNpwhdMgWCQydefAi9lKL0Ygc",
  authDomain: "chat-app-d7ce3.firebaseapp.com",
  projectId: "chat-app-d7ce3",
  storageBucket: "chat-app-d7ce3.appspot.com",
  messagingSenderId: "50617174775",
  appId: "1:50617174775:web:25e4bfe694d644704fe1f2",
  measurementId: "G-MGF8SXWE2T",
};

firebase.initializeApp(firebaseConfig);

export default firebase;
